module.exports = __webpack_public_path__ + "img/mycard.5f8e2147.png";